/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
    faUserSecret,
    faTasks,
    faCoins,
    faSpinner,
    faTrash,
    faPencilAlt,
    faAngleUp,
    faAngleDoubleLeft,
    faAngleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faEllipsis,
    faFilter,
    faCalendarDays,
    faPaperPlane,
    faChevronRight,
    faTrashCan
} from "@fortawesome/free-solid-svg-icons";

export default {
    install: (app, options) => {
        /* add icons to the library */
        library.add(
            faUserSecret,
            faTasks,
            faCoins,
            faSpinner,
            faTrash,
            faPencilAlt,
            faAngleUp,
            faAngleDoubleLeft,
            faAngleLeft,
            faAngleRight,
            faAngleDoubleRight,
            faEllipsis,
            faFilter,
            faCalendarDays,
            faPaperPlane,
            faChevronRight,
            faTrashCan
        );

        app.component("font-awesome-icon", FontAwesomeIcon);
    },
};
